import moment from "moment";
import { Replenishment } from "./replenishment";
import { Record, Map } from "immutable";

const defaults = {
    id: undefined,
    item: undefined,
    period_start: undefined,
    replenishments: undefined,
    warehouse: undefined,
};

export class ReplenishmentGroup extends Record(defaults) {
    declare id: string;
    declare item: string;
    declare warehouse: string;
    declare period_start: moment.Moment;
    declare replenishments: Map<string, Replenishment>;

    constructor(args) {
        super({
            ...args,
            period_start: moment.utc(args.period_start),
            replenishments: Map(
                args.replenishments && args.replenishments.map((val) => [val.sku_id, new Replenishment(val)]),
            ),
        });
    }
}
